import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Col,
  Row,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
} from "react-bootstrap";
import moment from "moment";
import { constants } from "redux/briefings/actions";
import { useNotifications } from "../hooks/useNotifications";
import NotificationSystem from "../components/NotificationSystem";
import LoadingSpinner from "views/Components/LoadingSpinner";
import { useBriefings } from "../hooks/useBriefings";
import { getFormattedUser } from "services/auth";

const {
  UPDATE_BRIEFING_FORM_FIELD,
  SUBMIT_BRIEFING_FORM,
  FETCH_BRIEFING,
  UPDATE_BRIEFING,
} = constants;

const BriefingForm = ({ match }) => {
  const { loading, error, success, notes, createdBy } = useSelector(
    (state) => state.briefings
  );
  const dispatch = useDispatch();
  const notificationSystem = useNotifications(success, error);
  const [userName, setUserName] = useState(null);
  const searchParams = new URLSearchParams(window.location.search);
  const readOnlyMode =
    searchParams.has("readOnly") && searchParams.get("readOnly") === "true";

  const { fetchBriefing, handleSubmitBriefing } = useBriefings();

  useEffect(() => {
    if (match.params.id) {
      fetchBriefing(match.params.id);
    }
    fetchUser();
  }, []);

  const fetchUser = async () => {
    const user = await getFormattedUser();
    setUserName(user.fullName);
  };

  const handleChange = (event) => {
    let field = null;
    let value = null;
    if (event._d) {
      field = "dateVerified";
      value = event._d;
    } else if (event.target) {
      field = event.target.name;
      value = event.target.value;
      value = value === "true" ? true : value;
      value = value === "false" ? false : value;
    } else {
      field = event;
      value = event;
    }
    dispatch({ type: UPDATE_BRIEFING_FORM_FIELD, field, value });
  };

  const submitRoute =
    match.params.id > 0 ? UPDATE_BRIEFING : SUBMIT_BRIEFING_FORM;

  const date = moment().format("MMMM DD, YYYY");

  if (loading.source === FETCH_BRIEFING) {
    return <LoadingSpinner loading={true} />;
  }

  return (
    <div className="main-content">
      <NotificationSystem ref={notificationSystem} />
      <Form>
        <Grid fluid>
          <Row>
            <Col xs={12} sm={6}>
              <FormGroup>
                <ControlLabel>Date</ControlLabel>
                <FormControl
                  type="text"
                  id="date"
                  name="date"
                  value={date}
                  disabled
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <FormGroup>
                <ControlLabel>Created By</ControlLabel>
                <FormControl
                  type="text"
                  id="name"
                  name="name"
                  value={submitRoute === UPDATE_BRIEFING ? createdBy : userName}
                  disabled
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12}>
              <FormGroup>
                <ControlLabel>Notes</ControlLabel>
                <FormControl
                  componentClass="textarea"
                  id="notes"
                  name="notes"
                  value={notes || ""}
                  disabled={readOnlyMode}
                  style={{ height: "200px" }}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>
          {!readOnlyMode && (
            <Row style={{ marginTop: 20 }}>
              <Col xs={12} sm={12}>
                <Button
                  style={{ marginRight: "15px" }}
                  bsStyle="primary"
                  bsSize="lg"
                  onClick={() =>
                    handleSubmitBriefing(submitRoute, match.params.id, notes)
                  }
                >
                  {match.params.id > 0 ? "Save" : "Submit"}
                </Button>
                <Button
                  bsStyle="warning"
                  bsSize="lg"
                  onClick={() =>
                    (window.location.href = "/admin/briefing-room")
                  }
                >
                  Back
                </Button>
              </Col>
            </Row>
          )}
        </Grid>
      </Form>
    </div>
  );
};

export default BriefingForm;
